import tw from "tailwind-styled-components";
import { FaChevronRight, FaReceipt } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { LuClipboardList } from "react-icons/lu";
import { TbBuilding } from "react-icons/tb";
import { MdOutlinePayment, MdDriveFileMoveOutline, MdOutlineAccountTree, MdSettings } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoReceipt } from "react-icons/io5";
import { AiOutlineNotification } from "react-icons/ai";
import { useSelector } from "react-redux";
import Config from "../../Config";

const settingsGroups = [
  {
    groupName: "Property Settings",
    options: [
      {
        title: "Agreement Settings",
        description: "Set agreement settings",
        icon: <LuClipboardList size={24} />,
        modalType: "RentingStayRules",
      },
      {
        title: "Renew Agreement Settings",
        description: "Configure agreement renewal settings",
        icon: <TbBuilding size={24} />,
        modalType: "RenewAgreement",
      },
      // {
      //   title: "Agreement Template",
      //   description: "Configure agreement template",
      //   icon: <FaReceipt size={24} />,
      //   modalType: "AgreementTemplate",
      // },
    ],
  },
  {
    groupName: "Tenant Settings",
    options: [
      {
        title: "Tenant Onboarding Settings",
        description: "Configure onboarding settings",
        icon: <FiUsers size={24} />,
        modalType: "OnboardingSettings",
      },
      {
        title: "Eviction Settings",
        description: "Manage eviction rules and process",
        icon: <MdDriveFileMoveOutline size={24} />,
        modalType: "EvictionSettings",
      },
    ],
  },
  {
    groupName: "Finance Settings",
    options: [
      {
        title: "Finance Settings",
        description: "Configure payment due dates and reminders",
        icon: <MdOutlinePayment size={24} />,
        modalType: "DuesSettings",
      },
      {
        title: "Rules & Receipt Settings",
        description: "Configure stay rules, receipt terms and billing conditions.",
        icon: <IoReceipt size={24} />,
        modalType: "ReceiptSettings",
      },
    ],
  },
  // {
  //   groupName: "Tally Settings",
  //   options: [
  //     {
  //       title: "Tally Settings",
  //       description: "Manage tally description",
  //       icon: <MdOutlineAccountTree size={24} />,
  //       modalType: "TellySettings",
  //     },
  //   ],
  // },
  {
    groupName: "General Settings",
    options: [
      {
        title: "Operational Controls",
        description: "Configure global operational settings",
        icon: <MdSettings size={24} />,
        modalType: "GlobalSettings",
      },
      {
        title: "Tally Settings",
        description: "Manage tally description",
        icon: <MdOutlineAccountTree size={24} />,
        modalType: "TellySettings",
      },
      {
        title: "Notification & Messages",
        description: "Manage communication settings",
        icon: <AiOutlineNotification size={24} />,
        modalType: "NotificationSettings",
      },
    ],
  },
  // {
  //   groupName: "Notification Settings",
  //   options: [
  //     {
  //       title: "Notification & Messages",
  //       description: "Manage communication settings",
  //       icon: <AiOutlineNotification size={24} />,
  //       modalType: "NotificationSettings",
  //     },
  //   ],
  // },
  // {
  //   groupName: "Report Settings",
  //   options: [
  //     {
  //       title: "Reports",
  //       description: "Easily Generate and Download Detailed Reports",
  //       icon: <FaRegFileAlt size={24} />,
  //       modalType: "Report",
  //     },
  //   ],
  // },
];

const Table = ({ setOpenModal, settingsData, setIsLogout }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.UserReducer.user);
  const isFinance =
    user?.role === Config.STAFF_ROLES.FINANCEADMIN &&
    user?.userType === Config.USER_TYPE.STAFF;

  // Filter settings groups based on isFinance
  const filteredGroups = settingsGroups
    .map(group => {
      // if (group.groupName === "Finance Settings" && isFinance) {
      //   return group;
      // }
      if (group.groupName === "General Settings" && isFinance) {
        return {
          ...group,
          options: group.options.filter(option =>
            option.title === "Tally Settings"
          )
        };
      }
      if (!isFinance) {
        return group;
      }
      return null;
    })
    .filter(group => group !== null && (group.options.length > 0 || group.groupName === "Finance Settings"));


  const handleOptionClick = (modalType) => {
    if (modalType === "Logout") {
      setIsLogout(true);
      return;
    }
    if (modalType === "Report") {
      navigate("/reports");
      return;
    }
    // if (modalType === "AgreementTemplate") {
    //   navigate("/agreement-template");
    //   return;
    // }
    if (modalType) {
      setOpenModal(modalType);
    }
  };

  return (
    <Wrapper>
      {/* {settingsGroups.map((group, groupIndex) => ( */}
      {filteredGroups.map((group, groupIndex) => (
        <GroupContainer
          key={groupIndex}
          $isLast={groupIndex === filteredGroups.length - 1}
        // $isLast={groupIndex === settingsGroups.length - 1}
        >
          <GroupHeader>
            <GroupTitle>{group.groupName}</GroupTitle>
          </GroupHeader>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {group.options.map((option, optionIndex) => (
              <OptionGroup
                key={`${groupIndex}-${optionIndex}`}
                onClick={() => handleOptionClick(option.modalType)}
                className={`cursor-pointer ${option.modalType ? "hover:bg-gray-100 transition" : ""
                  }`}
              >
                {/* <Header> */}
                {/* <div className="text-gray-600">{option.icon}</div> */}
                <IconWrapper>
                  {option.icon}
                </IconWrapper>

                <OptionContent>
                  <OptionTitle>{option.title}</OptionTitle>
                  <OptionDescription>{option.description}</OptionDescription>
                </OptionContent>

                <ChevronWrapper>
                  <FaChevronRight />
                </ChevronWrapper>
                {/* </Header> */}
              </OptionGroup>
            ))}
          </div>
        </GroupContainer>
      ))}
    </Wrapper>
  );
};

const Wrapper = tw.div`px-2 md:px-6`;
// const GroupContainer = tw.div`space-y-4 pb-8
//   ${({ $isLast }) => !$isLast ? 'border-b border-gray-200' : ''}
//   ${({ $isLast }) => $isLast ? 'pb-0' : 'mb-8'}
// `;
const GroupHeader = tw.div``;
//const GroupTitle = tw.h2`text-xl font-semibold text-gray-800 mb-2`;
//const OptionGroup = tw.div`py-4 px-2.5 md:p-5 bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md`;
const OptionGroup = tw.div`
  group flex items-center gap-3 md:gap-4
  p-4 md:p-5 bg-white rounded-xl
  border border-gray-200
  transition-all duration-200 ease-out
  cursor-pointer

  hover:-translate-y-[2px]
  hover:shadow-[0_8px_20px_rgba(0,0,0,0.06)]
  hover:border-gray-300
`;
//const Header = tw.div`flex items-center w-full px-0`;
//const OptionContent = tw.div`flex flex-col ml-2 md:ml-4`;
const OptionContent = tw.div`flex flex-col flex-1`;
//const ChevronWrapper = tw.div`text-gray-400 text-sm ml-auto`;
//const OptionTitle = tw.h3`text-gray-800 md:text-lg text-md font-medium`;
//const OptionDescription = tw.p`text-gray-500 text-sm`;

const Header = tw.div`flex items-center w-full`;

const IconWrapper = tw.div`
  flex items-center justify-center
  w-9 h-9 rounded-xl
  bg-gray-100 text-gray-600
  transition-all duration-200

  group-hover:bg-primary-color/10
  group-hover:text-primary-color
  group-hover:scale-105
`;

const OptionTitle = tw.h3`
  text-gray-800 text-sm md:text-base font-semibold
`;

const OptionDescription = tw.p`
  text-gray-500 text-xs md:text-sm mt-0.5
`;

const ChevronWrapper = tw.div`
  text-gray-300 text-sm ml-auto
  transition-all duration-200

  group-hover:text-gray-500
  group-hover:translate-x-1
`;

const GroupTitle = tw.h2`
  text-lg md:text-xl font-semibold text-gray-900
`;

const GroupContainer = tw.div`
  space-y-4 pb-8
  ${({ $isLast }) => !$isLast ? 'border-b border-gray-100' : ''}
  ${({ $isLast }) => $isLast ? 'pb-0' : 'mb-8'}
`;
export default Table;
